/** topcg/scr/routes.js  
 
    Define las rutas (paths) que accederá el programa, definiciendo las opciones que requieren autenticación.
    Desarrollado por JC Yocop
======================================================================================================== */

/** Importaciones */
import chgpass      from './components/chgpass.vue'
import home         from './components/home.vue'
import login        from './components/login.vue'
import logout       from './components/logout.vue'
import culturaG     from './components/culturaG.vue'
import tipologia    from './components/ev01_tipologia.vue'
import factores     from './components/ev02_16pf.vue'
import estabilidad  from './components/ev03_npf.vue'
import sociabilidad from './components/ev04_cpf.vue'
import perfil       from './components/ev05_fig.vue'
import supervision  from './components/ev06_moss.vue'
import aptitudvtas  from './components/ev07_tav.vue'
import solempleo    from './components/ev08_solemp.vue'
import emociones    from './components/ev09_emoc.vue'
import orientacion  from './components/ev10_vtas.vue'
import aedp         from './components/ev12_aedp.vue'
// import versionT     from './components/version3.vue'

import auxiliar     from './components/ev11_auxi.vue'

// import enviarmail   from './pruebas/sendmail.vue'
import cvs          from './pruebas/cvs.vue'

import consultas    from './components/ev_consultas.vue'

/** Exportaciones */
export const routes = [

    /* Ejemplos sencillos de la relación de un path (/saludo, p.ej) con su respectivo componente  meta: { requiresAuth: true }  */
    { path: '/',            name: 'home', component: home, meta: { requiresAuth: true } },
    { path: '/login',       name: 'login',      component: login, },
    { path: '/chgpass',     name: 'chgpass',    component: chgpass,     meta: { requiresAuth: true } },
//     { path: '/culturaG',    name: 'culturaG',   component: culturaG,    meta: { requiresAuth: true } },
    //* ok
    { path: '/tipologia',   name: 'tipologia',  component: tipologia,   meta: { requiresAuth: true } },
    { path: '/perfil',      name: 'perfil',       component: perfil,      meta: { requiresAuth: true } },
    { path: '/factores',    name: 'factores',   component: factores,    meta: { requiresAuth: true } },
    { path: '/estabilidad', name: 'estabilidad', component: estabilidad, meta: { requiresAuth: true } },
    { path: '/sociabilidad',name: 'sociabilidad', component: sociabilidad, meta: { requiresAuth: true } },
    { path: '/supervision', name: 'supervision', component: supervision,  meta: { requiresAuth: true } },
    { path: '/aptitudvtas', name: 'aptitudvtas', component: aptitudvtas,  meta: { requiresAuth: true } },
    { path: '/solempleo',   name: 'solempleo',   component: solempleo,    meta: { requiresAuth: true } },
    { path: '/emociones',   name: 'emociones',   component: emociones,    meta: { requiresAuth: true } },
    { path: '/orientacion', name: 'orientacion', component: orientacion,  meta: { requiresAuth: true } },
//     { path: '/versionT',    name: 'versionT',    component: versionT,     meta: { requiresAuth: true } },
    { path: '/auxiliar',    name: 'auxiliar',    component: auxiliar,     meta: { requiresAuth: true } },
    { path: '/aedp',        name: 'aedp',        component: aedp,         meta: { requiresAuth: true } },

     // { path: '/enviarmail', name: 'enviarmail', component: enviarmail, meta: { requiresAuth: true } },
     // { path: '/cvs',        name: 'cvs',          component: cvs, meta: { requiresAuth: true } },

     //? ok
    { path: '/consultas',  name: 'consultas',   component: consultas,   meta: { requiresAuth: true } },
    { path: '/logout', component: logout, name: 'logout', meta: { requiresAuth: true } },

    { path: '*', redirect: '/login' },
];




// WEBPACK FOOTER //
// ./src/routes.js